// extracted by mini-css-extract-plugin
export default {"Success":"Success_Success__2sV4s"};